import React from "react";
import AllProducts from "./ProductsModule/AllProducts";

const Products = () => {
  return (
    <div>
      <AllProducts />
    </div>
  );
};

export default Products;
